import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';

export const TrackingClass = ({ trackingClass }: { trackingClass?: 'BOOKING' }) => {
  const { t } = useTranslate();

  if (trackingClass === 'BOOKING') {
    return <BookingTag>{t('预先履行')}</BookingTag>;
  }
  return null;
};

const BookingTag = styled.div`
  display: inline-block;
  padding: 1px 4px;
  line-height: 18px !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  color: var(--ant-primary-color) !important;
  background: var(--ant-primary-2);
  border-radius: 2px;
  width: fit-content;
`;
